import { bool, node, string } from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Wrapper = styled.small`
  color: #696969;
  font-size: 0.75rem;

  &.se-form-help--invalid {
    color: #cf142b;
  }
`;

function Message({ children, isError, className }) {
  const componentClass = classNames(
    className,
    'se-form-help', {
      'se-form-help--invalid': isError,
    });

  return (
    <Wrapper className={componentClass}>{children}</Wrapper>
  );
}

Message.propTypes = {
  children: node.isRequired,
  isError: bool,
  className: string,
};

Message.defaultProps = {
  isError: false,
  className: '',
};

export default styled(Message)``;